import { Card } from './ui/card';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

export const Benefits = () => {
  const benefits = [
    {
      title: 'Down payments & closing costs',
      description: 'how much you really need saved so you can plan without stress'
    },
    {
      title: 'First-time homebuyer programs',
      description: 'explore the most popular mortgage options and see if you qualify'
    },
    {
      title: 'Credit repair expertise',
      description: 'get connected with proven strategies to improve your credit score'
    },
    {
      title: 'First steps',
      description: 'where to start, who you need on your team, and how to build a smart action plan'
    },
    {
      title: 'The full homebuying process',
      description: 'understand each step so you can avoid surprises and feel in control'
    },
    {
      title: 'The current market',
      description: 'insider tools & strategies to help you compete (and win) in today\'s market'
    }
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Overwhelmed by the <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">Homebuying Process?</span>
            </h2>
            <p className="text-2xl font-semibold text-slate-700">
              We'll Walk You Through It Step by Step
            </p>
          </div>

          <Card className="bg-white shadow-xl p-8 md:p-12 border-t-4 border-yellow-500">
            <p className="text-xl text-slate-700 mb-8">
              In this free masterclass, you'll walk away knowing:
            </p>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-4 group">
                  <div className="flex-shrink-0">
                    <CheckCircle2 className="w-7 h-7 text-yellow-500 group-hover:scale-110 transition-transform" />
                  </div>
                  <div>
                    <span className="font-bold text-slate-900 text-lg">{benefit.title}</span>
                    <span className="text-slate-600"> — {benefit.description}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 p-8 bg-gradient-to-r from-blue-50 to-slate-50 rounded-lg border-l-4 border-blue-600">
              <p className="text-lg text-slate-800 leading-relaxed">
                You don't have to keep wondering if you're "ready."
              </p>
              <p className="text-xl font-semibold text-slate-900 mt-4">
                Take the guesswork out of homeownership — and start your path to buying your first home with confidence.
              </p>
            </div>

            <div className="text-center mt-10">
              <Button
                onClick={scrollToTop}
                className="bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white font-bold py-6 px-12 text-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
              >
                Save My Spot
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
